import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# **Response Validations**

HawkClient allows you to perform validations on API responses using a simple and intuitive UI.  
This helps ensure your APIs return expected data, status codes, and structures.

The **Validation tab** consists of three main fields:

---

## **Variable / Expression**

The value from the response you want to validate.  
You can access fields from the **response** object such as:

- **response.body.token**
- **response.status**
- **response.statusText**
- **response.headers['content-type']**

---

## **Operator**

A dropdown list of comparison operators including:

- **isEqualTo**, **isNotEqualTo**
- **contains**, **notContains**
- **isGreaterThan**, **isLessThan**
- **isString**, **hasLength**
- and many more

---

## **Value**

The expected value or condition you want to validate against the selected expression.

---

![Validations in HawkClient](/validations.png)

---

## **Supported Operators**

HawkClient supports a wide range of operators for flexible validations:

- **isGreaterThan**
- **isGreaterThenOrEqual**
- **isEqualTo**
- **isNotEqualTo**
- **isLessThen**
- **isLessThenOrEqual**
- **contains**
- **notContains**
- **startWith**
- **endWith**
- **matchesRegex**
- **between**
- **notBetween**
- **isEmpty**
- **isUnDefined**
- **isNull**
- **isTrue**
- **isFalse**
- **isTypeOf**
- **isArray**
- **isObject**
- **isString**
- **isNumber**
- **isBoolean**
- **hasLength**

---

These validations help you automatically assert API correctness  
**without writing any custom scripts**.
`;

const Validations = () => {
    return (
        <MarkDownRenderer
            title="Response Validations"
            markDownText={markdownContent}
        />
    );
};

export default Validations;
